export * from './grant-activity-to-geek.model';
